import { Box } from '@mui/material';
import { func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import WorkingDays from 'components/controls/WorkingDays';

import SelectTitle from '../SelectTitle';

const WorkingDaysSettings = props => {
  const { value, onChange } = props;

  return (
    <Box sx={{ mt: '20px', pr: '20px' }}>
      <SelectTitle headline={I18n.t('SettingsDrawer.Hours')} />
      <WorkingDays value={value} onChange={onChange} />
    </Box>
  );
};

WorkingDaysSettings.propTypes = {
  value: object.isRequired,
  onChange: func.isRequired,
};

export default WorkingDaysSettings;
